import React from 'react';
import PropTypes from 'prop-types';
import A11ySvg from 'components/A11ySvg';
import './PinIcon.css';

function PinIcon({ className, size, title, alt, filled, disabled }) {
  const setClassName = `pin-icon ${className || ''}${size || ''}${
    filled ? ' filled' : ''
  }${disabled ? ' disabled' : ''}`;
  return (
    <A11ySvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="115 1018 20 20.3"
      className={setClassName}
      title={title}
      alt={alt}
    >
      <g transform="translate(115 1018)">
        <path d="M25,23.6l-2,2,8.5,6.5Z" transform="translate(-11.5 -11.8)" />
        <path d="M3,2.8H3L5.85,0l3.9,5.55c5,.05,6.45,2.1,6.45,2.1L11.5,12.3l-4,4s-2-1.5-2-6.5L0,5.8Z" />
      </g>
    </A11ySvg>
  );
}

PinIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default PinIcon;
